import { Box, Skeleton, Stack } from '@mui/material';

const LoadingSkeleton = () => {

    return (
        <Stack spacing={2} sx={{ p: 2 }}>
            <Skeleton variant="text" width={240} height={36} />

            <Skeleton variant="rectangular" width="100%" height={48} />

            <Box>
                <Skeleton variant="rectangular" width="100%" height={220} sx={{ mb: 1 }} />
                <Skeleton variant="rectangular" width="100%" height={220} />
            </Box>
        </Stack>
    );
}

export default LoadingSkeleton;
